$(function () {
  $('.fa-bars').click(function() {
    $('header').addClass('menu_enable');
    $('.sp_menu_btn').addClass('menu_enable');
    $('.main_view2').addClass('fixed');
  });
});
$(function () {
  $('.fa-times,.close_menu').click(function() {
    if($(window).scrollTop() < $('.main_container').offset().top - 2 && $('.main_view2').hasClass('fixed')) {
      $('header').removeClass('menu_enable');
      $('.sp_menu_btn').removeClass('menu_enable');
      $('.main_view2').removeClass('fixed');
    } else {
      $('header').removeClass('menu_enable');
      $('.sp_menu_btn').removeClass('menu_enable');
    }
  });
});


$(window).load(function () {
  var view = $('.main_view2'),
      point = $('.main_container'),
      offset = point.offset();

  $(window).scroll(function () {
    if($(window).scrollTop() < offset.top - 2 && $('header').hasClass('menu_enable')) {
      view.addClass('fixed');
    } else if($(window).scrollTop() > offset.top - 2 && !$('header').hasClass('fixed')) {
      view.addClass('fixed');
    } else {
      view.removeClass('fixed');
    }
  });
});

$(function () {
  var headerHight = 90;
  $('a[href^=#]').click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top-headerHight;
    console.log(position)
    $("html, body").animate({scrollTop:position}, 600, "swing");
    return false;
  });
});
$(function () {
  $('.to_top').click(function(){
    $("html, body").animate({scrollTop:0}, 600, "swing");
    return false;
  });
});


var $win = $(window);

$win.on('load resize', function() {
  var windowWidth = $win.width();
  if (windowWidth > 801) {
    $('.list_item_img').css({"display":"none"});
  }
});
$('.list_item_img').each(function(){
  $('.list_item_img').css({"display":"block"});
  $(this).css("height",$(this).height()+"auto");
});
$('.list_item_img').hide();
$('.goods_item_list').click(function () {
  $(this).next('.list_item_img').slideToggle('100').siblings('.list_item_img').slideUp('100');
  $(this).toggleClass("active");
});
